import CompanyFormFooter from './CompanyFormFooter'

export default CompanyFormFooter
